export enum ServicePath {
  WorkflowServiceGraphql = "/api/workflows/graphql",
  NotificationsServiceGraphql = "/api/bnp-notifications/graphql",
  UserActivityServiceGraphql = "/api/bnp/graphql",
  AccessServiceGraphql = "/api/access/graphql",
  ChartOfAccountsServiceGraphql = "/api/coa/graphql",

  EntitiesV1 = "/api/v1/entities",
  SessionV1 = "/api/v1/session",
  FormServiceV1 = "/api/form_service/v1",
  BudgetsV1 = "/api/v1/budgets",
  ReportsV1 = "/api/v1/reports",
  ReportingServiceV2 = "/api/reporting_service/v2",
  ReportingServiceV4 = "/api/reporting_service/v4",
  UsersV1 = "/api/v1/users",
  AccessPolicyV1 = "/api/access/policy/v1",
  AccessGroupV1 = "/api/access/group/v1",
  StrategicInitiativesV1 = "/api/si_service/v1",
  DatasetsV1 = "/api/datasets/v1",

  SessionV3 = "/api/v3/session",
  BudgetsV3 = "/api/v3/budgets",
  ProposalsV3 = "/api/v3/proposals",
  ChartOfAccountsV3 = "/api/v3/chart_of_accounts",
}
